import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-aphone",
  "use": "icon-aphone-usage",
  "viewBox": "0 0 20 28",
  "content": "<symbol viewBox=\"0 0 20 28\" id=\"icon-aphone\">  <image id=\"icon-aphone_image0\" width=\"20\" height=\"28\" x=\"0\" y=\"0\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAMAAABWBG9SAAAABGdBTUEAALGPC/xhBQAAACBjSFJN\nAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAZlBMVEUdkfMdkfMdkfMdkfMd\nkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMd\nkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfMdkfP///9KwAVCAAAAIHRSTlMAWNf89sO7WdT1Ksbn\nmcsi++733R0l+C3+LtUpOMD9WurvYLgAAAABYktHRCHEbA0WAAAAB3RJTUUH4gcNDigYk70PEgAA\nAH5JREFUKM/l0lkOgzAMBNBJQoCw72XH9z8lIAQybm/Q9xWNFP/MAEobYoxWgCLP+oz1KEDoIrxE\nLoSJIcQGlKRCQqAfQFkuZEdo5U3752FRCsURVrVQse9N832z7br2Ce/iPn0/PMWNbrre83xXPJ5j\nWPgYlnMMCPTKm1z1hh2+QRMkFnnhDwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0xM1QxNDo0\nMDoyNCswODowMLnbftYAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMTNUMTQ6NDA6MjQrMDg6\nMDDIhsZqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAABJRU5ErkJggg==\"></image>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/aphone.svg
// module id = sAOv
// module chunks = 20